<template lang="pug">
  .procurement-choose-quotation-and-confirm-vendor(v-loading="loading")
    title-bar {{ $t('采购部选择供应商') }}
    template(v-if="isView && viewData && data")
      sub-final-scope-view(
        v-if="isView && viewData && data"
        v-for="s, i in viewData"
        :key="i"
        :viewData="viewData[i]"
        :data="data[i]"
        :index="i"
      )
    template(v-if="!isView && data")
      sub-final-scope(
        v-for="s, i in data"
        v-model="data[i]"
        :index="i"
        :key="i"
      )
    el-row(
      v-if="!isView"
      style="margin-left: 20px"
    )
      el-col(
        :span="10"
        :offset="4"
      )
        footer-button(
          :confirmButton="$t('下一步')"
          @confirm="submit"
          @cancel="$router.push('/campaign/process')"
          :buttonWidth="isZh ? '65px' : '100px'"
        )
</template>

<script>
import TitleBar from '@/components/TitleBar'
import SubFinalScope from './SubFinalScope'
import SubFinalScopeView from './SubFinalScopeView'
import SubmitToIt from './SubmitToIT'
import axios from 'axios'
import { format4backend } from '@/umcc/util'
import FooterButton from '@/components/FooterButton'
import db from '@/umcc/db'
import DisplayTextContainer from '@/components/DisplayTextContainer'

const getSubFinalScopeForPurchase = (campaignID, isApproved) => {
  return axios.get('/management/subfinal/getSubFinalScopeForPurchase', {
    params: {
      campaign_id: campaignID,
      is_approved: isApproved
    }
  })
}

export default {
  components: {
    TitleBar,
    SubFinalScope,
    SubmitToIt,
    FooterButton,
    SubFinalScopeView,
    DisplayTextContainer
  },
  data () {
    return {
      data: null,
      viewData: null,
      selectedId: null,
      dialogVisible: false,
      loading: false
    }
  },
  computed: {
    isZh () {
      return db.lang === 'zh'
    },
    campaignId () {
      return this.$store.state.campaign.id
    },
    phaseType () {
      return this.$store.state.campaign.phaseType
    },
    campaign () {
      return this.$store.state.campaign
    },
    isApproved () {
      return this.isView ? 1 : 0
    }
  },
  mounted () {
    this.loading = true
    getSubFinalScopeForPurchase(this.campaignId, this.isApproved)
      .then((res) => {
        this.loading = false
        this.data = res
        this.data.forEach(d => {
          d.remark = ''
        })
      })
      .catch(err => {
        this.loading = false
        throw new Error(err)
      })
    if (this.isView) {
      this.getLog()
    }
  },
  methods: {
    getLog () {
      return axios
        .get('/common/getBusinessLog', {
          params: {
            servlet_path: this.$route.path,
            business_key: this.campaignId
          }
        })
        .then((res) => {
          this.viewData = res.sub_final_scope_vendor_choice
        })
    },
    submit () {
      if (this.validate()) {
        this.$message.error(this.$t('请为每个Sub SOW确定一家供应商'))
        return
      }
      const params = {
        campaign_id: this.campaignId,
        servlet_path: this.$route.path,
        task_name: this.campaign.taskName,
        task_id: this.campaign.taskId,
        sub_final_scope_vendor_choice: this.data.map(d => {
          return {
            sub_final_scope_id: d.sub_final_scope_id,
            vendor_id: d.selectedVendor,
            remark: d.remark
          }
        })
      }
      this.loading = true
      axios
        .post('/management/subfinal/saveVendorChoice', format4backend(params))
        .then(() => {
          this.$router.push('/campaign/process')
          this.getLog()
        })
    },
    validate () {
      return this.data.some((d) => {
        return !d.selectedVendor
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.procurement-choose-quotation-and-confirm-vendor
  .footer-button
    padding-left 0
</style>
